import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import ErrorBoundary from "./components/hooks/Utils/ErrorBoundary"
import { UserProvider } from "./components/hooks/Contexts/UserContext/UserContext"
import { BusinessProvider } from "./components/hooks/Contexts/BusinessContext/BusinessContext"
import { ThemeProvider, createTheme } from "@mui/material"
import { CacheProvider } from "@emotion/react"
import createCache from "@emotion/cache"
import rtlPlugin from "stylis-plugin-rtl"
import { prefixer } from "stylis"

const theme = createTheme({ direction: "rtl" })

// Cache שמחיל RTL על כל ה-CSS של Emotion/MUI
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <UserProvider>
        <BusinessProvider>
          <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </CacheProvider>
        </BusinessProvider>
      </UserProvider>
    </ErrorBoundary>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
